export default "dist/e6a645fcf4854b6287dbedff0a6a2ce5.woff";